// Mixins
import { userMixins } from '@/app/mixins/modules/user-mixins';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { imageCompressorMixins } from '@/app/mixins/utils/image-compressor-mixins';

// Third Party libraries
const vue2Dropzone = () => import(/*webpackPrefetch: true, webpackChunkName: "vue-dropzone"*/ 'vue2-dropzone');

// Services
import PostService from '@/app/services/main/post/post-service.js';

// Constants
import { ERROR_MSG } from '@/app/constants/status-constants';
import { STATUS_CODES } from '@/app/constants/status-constants';

export default {
    name: 'SocialClubCreatePost',
    components: {
        vueDropZone: vue2Dropzone
    },
    props: {
        topic: {
            type: String,
            required: true
        },
        groupId: {
            type: Number,
            dafault: 1001
        }
    },
    mixins: [userMixins, toastMessageMixins, imageCompressorMixins],
    data() {
        return {
            postInput: '',
            dropOptions: {
                url: 'https://httpbin.org/post', // endpoint where files needs to be sent. Currently mocked.
                thumbnailWidth: null,
                thumbnailHeight: null,
                maxFilesize: 20,
                maxThumbnailFilesize: 20,
                acceptedFiles: '.svg, .png, .jpg, .gif, .jpeg',
                headers: { 'Authorization': 'Bearer mock authorization' },
                uploadMultiple: true,
                autoProcessQueue: false,
                maxFiles: 6,
                addRemoveLinks: true,
                clickable: '.uploadButtonCreate',
                dictFileTooBig: 'File Size must not exceed 20 MB.',
                dictInvalidFileType: 'Unsupported File Format.',
                dictRemoveFile: "<i class='fa fa-close'></i>",
                dictDefaultMessage: "<i class='fa fa-cloud-upload mr-2'></i> Drag images to upload. Maximum of 6 images."
            },
            fileCount: 0,
            isCreatingPost: false,
            onDragStyle: false,
            isBehind: false,
            showCardBody: false,
            windowWidth: window.innerWidth
        }
    },
    watch: {
        getHasUnsavedChanges(newVal) {
            if (!newVal) {
                // Clean post input state
                this.$refs.content.innerHTML = '';
                this.postInput = '';
                this.$refs.postDropZone.removeAllFiles();
            }
        }
    },
    computed: {
        isSubmitButtonDisabled() {
            return (this.postInput === '' && this.fileCount === 0) || this.isCreatingPost;
        },
        isMobile() {
            let isMobile = false;
            if (this.windowWidth <= 767) {
                isMobile = true;
            }
            return isMobile;
        },
        getHasUnsavedChanges() {
            return this.$store.getters.getHasUnsavedChanges;
        }
    },
    created() {
        window.addEventListener('resize', this.onResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
    methods: {
        populateInput(evt) {
            this.postInput = evt.target.innerText.trim();
        },
        handleBlur(evt) {
            let payload = false;
            this.postInput = this.postInput.trim();
            evt.target.innerText = this.postInput;

            if (this.postInput.trim()) {
                payload = true;
            }

            this.$store.commit('setHasPost', payload);
        },
        async createPost() {
            const { id, firstName, lastName } = this.getUserDetails();
            const formDetails = {
                groupId: this.groupId,
                topic: this.topic
            }

            if (this.postInput) {
                formDetails.content = this.postInput;
            }

            const images = await this.compressMultipleImages(this.$refs.postDropZone.getAcceptedFiles());

            this.isCreatingPost = true;

            const res = await PostService.createPost({ formDetails, images });
            if (res.status === STATUS_CODES.SUCCESS) {
                const { data: { post: { postId, mediaFiles } } } = res;
                
                const createdPost = {
                    id: postId,
                    firstName,
                    lastName,
                    userId: id,
                    createdAt: new Date(),
                    updatedAt: new Date(),
                    mediaFiles,
                    ...formDetails
                }

                // Clean post input state
                this.$refs.content.innerHTML = '';
                this.postInput = '';
                this.$refs.postDropZone.removeAllFiles();
                // Add the new post on feeds
                this.$emit('newPostCallback', createdPost);
                // Clear store state
                this.$store.commit('setHasPost', false);
                this.$store.commit('setHasPostImage', false);
            } else {
                const { ERROR_SAVE_POST } = this.toastMessages.post();
                this.showAPIErrorToast(ERROR_SAVE_POST, res);
            }

            this.isCreatingPost = false;
        },
        onAddedFile() {
            this.fileCount++;
            this.isBehind = false;

            this.triggerHasImage();
        },
        onRemovedFile() {
            this.fileCount--;

            this.triggerHasImage();
        },
        triggerHasImage() {
            const payload = this.fileCount > 0;

            this.$store.commit('setHasPostImage', payload);
        },
        onDropZoneError(file, message) {
            if (message !== ERROR_MSG.DROPZONE_UPLOAD_CANCELLED) {
                this.showCustomErrorToast(ERROR_MSG.DROPZONE_UPLOAD_ERROR_TITLE, message);
            }

            this.$refs.postDropZone.removeFile(file);
        },
        onDropZoneOver() {
            this.onDragStyle = true;
        },
        onDragEnter() {
            this.isBehind = true;
        },
        showCreateGroupModal() {
            // Open create group modal under social club container component
            this.$emit('showCreateGroupModal');
        },
        toggleShowCardBody () {
            this.showCardBody = !this.showCardBody;

            // clear store post
            if (!this.showCardBody) {
                this.$store.commit('setHasPost', false);
                this.$store.commit('setHasPostImage', false);
            }
        },
        onResize() {
            this.windowWidth = window.innerWidth;
        }
    }
}